import Link from 'next/link';

import { Alert, Anchor } from '@mantine/core';

import { TeamHelpers } from 'helpers/TeamHelpers';

import { useCurrentTeam } from 'hooks/use-current-team';

const HeaderPastDueNotice = () => {
    const currentTeam = useCurrentTeam();

    if (!currentTeam || !currentTeam.subscriptionPastDue) {
        return null;
    }

    return (
        <Alert color="red" p="xs" radius="md" py={4}>
            Your subscription payment is past due!{' '}
            <Anchor component={Link} href={TeamHelpers.urls.managePlan(currentTeam.id)} fw="bold">
                Learn more
            </Anchor>
        </Alert>
    );
};

export { HeaderPastDueNotice };
